// Minimal JWT utilities and cookie helpers

export function parseJwt(token) {
  try {
    const parts = token.split(".");
    if (parts.length < 2) return null;
    const payload = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(payload)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(json);
  } catch (e) {
    return null;
  }
}

export function setCookie(name, value, expiresAt) {
  let cookie = `${name}=${value}; path=/; samesite=lax`;
  if (expiresAt) {
    cookie += `; expires=${new Date(expiresAt).toUTCString()}`;
  }
  document.cookie = cookie;
}

export function deleteCookie(name) {
  document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

export function persistAuth({ token, user, roles, role, expiresAt }) {
  const payload = { token, user, roles, role, expiresAt };
  try {
    localStorage.setItem("auth", JSON.stringify(payload));
  } catch (e) {}
  setCookie("token", token, expiresAt);
}

export function clearAuthStorage() {
  try {
    localStorage.removeItem("auth");
    localStorage.removeItem("userId");
  } catch (e) {}
  deleteCookie("token");
}

export function getAuth() {
  try {
    return JSON.parse(localStorage.getItem("auth"));
  } catch (e) {
    return null;
  }
}

export function getToken() {
  return getAuth()?.token || null;
}

export function getUser() {
  return getAuth()?.user || null;
}

export function getRole() {
  return getAuth()?.role || null;
}

export function isAuthenticated() {
  return !!getToken();
}
